
// common input attributes
export const commonInputAttrs = {
  'hide-details': 'auto',
  outlined: true,
  class: 'rounded-xxl mb-3 tlm-text-field'
}

export default {}
